import React, { useEffect, useState } from "react";
import { subscribeDownloadLoading } from "../services/downloadLoading";

export default function DownloadLoadingModal() {
  const [active, setActive] = useState(false);

  useEffect(() => subscribeDownloadLoading(setActive), []);

  // Trava o scroll da página enquanto o modal estiver aberto.
  useEffect(() => {
    if (active) {
      const previous = document.body.style.overflow;
      document.body.style.overflow = "hidden";
      return () => {
        document.body.style.overflow = previous;
      };
    }
  }, [active]);

  if (!active) return null;

  return (
    <div className="download-loading-overlay">
      <div className="download-loading-box">
        <div className="download-loading-spinner" />
        <p className="download-loading-title">Baixando seus cadernos...</p>
        <p className="download-loading-text">
          Aguarde, este processo pode demorar um pouco.
        </p>
      </div>
    </div>
  );
}
